import {isAPIError} from "@/utils/isAPIError";
import {ApiError} from "@devour/client";


export async function getApiErrorMessage(error?: { json: () => Promise<ApiError> } | ApiError): Promise<string> {
    let errorMessage: string;

    /*
     * Unwrap the generated client's ResponseError.
     *
     * Since openapi-generator 7.14.0 the client throws a ResponseError that holds
     * the Response on `.response`; it has no `.json()` of its own. Callers pass the
     * error straight in, so without this the `.json()` below throws, is swallowed
     * by the catch, and EVERY failure degrades to the generic "unknown error" —
     * hiding whatever the backend actually said.
     *
     * Unwrapped here rather than at each call site because there are seven of them
     * (RTTR serial/post/invite/QR, tournament score submission, match detail) and a
     * per-caller fix leaves the same trap for the next one. Idempotent: a raw
     * Response has no `.response`, so it falls through unchanged.
     */
    const unwrapped = (error as { response?: unknown })?.response ?? error;

    try {
        if (isAPIError(error)) {
            errorMessage = (error as ApiError).message;
        } else {
            const jsonResponse = await (unwrapped as { json: () => Promise<ApiError> }).json();
            if (isAPIError(jsonResponse)) {
                errorMessage = jsonResponse.message;
            } else { // default error message
                errorMessage = "An unknown error has occurred. Please contact support or try your request again.";
            }
        }
    } catch (e) {
        errorMessage = "An unknown error has occurred. Please contact support or try your request again.";
    }

    // Chrome: "Failed to fetch", Safari/iOS: "Load failed"
    if (errorMessage === "Failed to fetch" || errorMessage === "Load failed") {
        errorMessage = "There was an error with your connection to the server. Please confirm you are connected to the internet, your adblocker is off, and your network is not blocking any network request. If the issue continues, please try refreshing the page.";
    }

    return errorMessage;
}